import React from "react";
import { graphql } from "gatsby";
import { PageBuilderOffersSelectionMosaicFragment } from "types/graphql-types";
import { WindowLocation } from "@reach/router";
import PageBuilderSectionTitle from "components/PageBuilder/PageBuilderSectionTitle";
import OffersSelectionMosaic from "components/CollectionMosaic/OffersSelectionMosaic";
import { isPresent } from "src/utils/checks";
import { MosaicLayoutVariantType } from "@silversea-ssc/ui-components-react";

export type PageBuilderOffersSelectionMosaicProps = PageBuilderOffersSelectionMosaicFragment & {
  location: WindowLocation;
};

const PageBuilderCollectionMosaic: React.FC<PageBuilderOffersSelectionMosaicProps> = ({
  heading,
  offers,
  mosaicVariant,
  location
}) => {
  const mosaicColumnVariant = (mosaicVariant ||
    "column3") as MosaicLayoutVariantType;
  const offerIds = offers?.map((x) => x?.sanityId)?.filter(isPresent) || [];

  return (
    <React.Fragment>
      <PageBuilderSectionTitle {...heading} />

      <OffersSelectionMosaic
        requiredOfferIds={offerIds}
        variant={mosaicColumnVariant}
        location={location}
      />
    </React.Fragment>
  );
};

export default PageBuilderCollectionMosaic;

export const fragments = graphql`
  fragment PageBuilderOffersSelectionMosaic on SanityOffersSelectionMosaic {
    _key
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }
    mosaicVariant
    offers {
      ... on SanityExclusiveOfferPerAirPromo {
        sanityId: _id
        _key
      }

      ... on SanityExclusiveOfferPerPromo {
        sanityId: _id
        _key
      }
    }
  }
`;
